// TODO: later rename file to api-collaboration and add `collaboration` prefix to all functions.
import axios, { AxiosInstance, AxiosResponse } from "axios";

import { MonitoringEventType, MonitoringStatsType } from "../shared/types/monitoring";

import { store } from "store/index";
import { selectUserIsInactive, selectUserJWT } from "store/selectors";
import { retryOnNetworkError } from "utils/api";
import { logInfoWithDebugFlag } from "utils/logger";

export const monitoringServerApi: AxiosInstance = axios.create({
  baseURL: `${window._env_.MONITORING_URL}`,
  withCredentials: true,
  xsrfCookieName: "csrftoken",
  xsrfHeaderName: "x-csrftoken",
});

monitoringServerApi.interceptors.request.use((config) => {
  const state = store.getState();
  const userIsInactive = selectUserIsInactive(state);
  if (userIsInactive) {
    // Abort the request instead of throwing an error to prevent it from reaching rollbar
    const method = config.method?.toUpperCase() || "UNKNOWN";
    const url = config.url || "UNKNOWN";
    logInfoWithDebugFlag("debug_sockets", "Canceling request due to inactive user", {
      method,
      url,
    });
    const abortController = new AbortController();
    abortController.abort();
    // eslint-disable-next-line no-param-reassign
    config.signal = abortController.signal;
  }

  if (!config.headers.Authorization) {
    const jwt = selectUserJWT(state);
    // eslint-disable-next-line no-param-reassign
    config.headers.Authorization = `Bearer ${jwt}`;
  }

  return config;
});

export async function serverGetMonitoringStats(courseId?: string) {
  return retryOnNetworkError(async () => {
    let url = `/api/v1/monitoring-stats`;
    if (courseId) {
      url += `?courseId=${courseId}`;
    }
    const response: AxiosResponse<MonitoringStatsType> = await monitoringServerApi.get(url);
    return response.data;
  }, "serverGetMonitoringStats");
}

export async function serverPostMonitoringEvent(event: MonitoringEventType) {
  return retryOnNetworkError(async () => {
    const { contextData, ...rest } = event;
    const payload = {
      contextData: JSON.stringify(contextData),
      ...rest,
    };
    const response = await monitoringServerApi.post(`/api/v1/monitoring-events`, payload);
    return response.data as void;
  }, "serverPostMonitoringEvent");
}

export async function serverGetCourseUserCounts() {
  return retryOnNetworkError(async () => {
    const response = await monitoringServerApi.get(`/api/v1/course-user-counts`);
    return response.data as Record<string, number>;
  }, "serverGetCourseUserCounts");
}
